module.exports = __webpack_public_path__ + "images/jumpstart-site-banner-bg.jpg";